import React, {Fragment} from 'react'
import PropTypes from 'prop-types'
import SVG from '../Atoms/SVG'
import styled from 'styled-components'

const Checkbox = ({id, onChange, checked, uncheckedColor, checkedColor}) => {
    return (
        <Fragment>
            <StyledSVG
                icon={checked ? 'checkboxChecked' : 'checkboxUnchecked'}
                color={checked ? checkedColor : uncheckedColor}/>
            <Input
                type={'checkbox'}
                id={id}
                onChange={onChange}
                checked={checked}/>
        </Fragment>
    )
}

Checkbox.propTypes = {
    id: PropTypes.string.isRequired,
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.func,
    checkedColor: PropTypes.string,
    uncheckedColor: PropTypes.string,
}

export default Checkbox

const Input = styled.input`
    display: none;
`

const StyledSVG = styled(SVG)`
    margin-right: 10px;
    display: flex;
    > svg {
        height: 18px;
    }
`



// WEBPACK FOOTER //
// ./src/jsx/Components/Presentational/Atoms/Checkbox.jsx